import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  user: null,
  token: localStorage.getItem('access_token'),
  isLoading: false,
  error: null,

  setUser: (user) => set({ user }),
  
  setToken: (token) => {
    if (token) {
      localStorage.setItem('access_token', token);
    } else {
      localStorage.removeItem('access_token');
    }
    set({ token });
  },
  
  setLoading: (isLoading) => set({ isLoading }),
  
  setError: (error) => set({ error }),
  
  login: async (user, token) => {
    set({ user, token: token, isLoading: false });
    localStorage.setItem('access_token', token);
  },
  
  logout: () => {
    set({ user: null, token: null });
    localStorage.removeItem('access_token');
  },
  
  clearError: () => set({ error: null }),
}));
